import React from 'react';
import {ONE_TIME_PAYMENT_DURATION} from '../../settings';
import {getSessionStorageField, setSessionStorageField} from '../contextHelper';

let oneTimePaymentCountDownInteral;

const useOneTimePaymentToken = ({authAndContent}) => {
  const [oneTimePaymentToken, setOneTimePaymentToken] = React.useState(
    getSessionStorageField('oneTimePaymentToken', null)
  );
  const [oneTimePaymentExpiryTime, setOneTimePaymentExpiryTime] =
    React.useState(getSessionStorageField('oneTimePaymentExpiryTime', null));

  const [oneTimePaymentTimeLeft, setOneTimePaymentTimeLeft] = React.useState(
    () => {
      const expTime = getSessionStorageField('oneTimePaymentExpiryTime', null);
      const timeLeft = expTime && expTime - Date.now();
      return timeLeft > 0 ? timeLeft : 0;
    }
  );

  const addOneTimePaymentMethod = React.useCallback(() => {
    setOneTimePaymentToken(prev => {
      const newToken = {...prev, saved: true};
      setSessionStorageField('oneTimePaymentToken', newToken);
      return newToken;
    });

    const expiryDate = Date.now() + ONE_TIME_PAYMENT_DURATION;
    setOneTimePaymentExpiryTime(expiryDate);
    setSessionStorageField('oneTimePaymentExpiryTime', expiryDate);

    authAndContent.setSnackBarMessage('One Time Payment Card Added');
  }, [authAndContent]);

  const removeOneTimePaymentMethod = React.useCallback(() => {
    clearInterval(oneTimePaymentCountDownInteral);
    setOneTimePaymentTimeLeft(0);

    setOneTimePaymentToken(null);
    setSessionStorageField('oneTimePaymentToken', null);

    setOneTimePaymentExpiryTime(null);
    setSessionStorageField('oneTimePaymentExpiryTime', null);
  }, []);

  React.useEffect(() => {
    if (!authAndContent.token) {
      removeOneTimePaymentMethod(); // if logged out, clear One Time Payment info in Session Storage
    }
  }, [authAndContent.token, removeOneTimePaymentMethod]);

  React.useEffect(() => {
    if (oneTimePaymentExpiryTime) {
      const intervalOperation = () => {
        setOneTimePaymentTimeLeft(() => {
          const timeLeft = oneTimePaymentExpiryTime - Date.now();
          return timeLeft > 0 ? timeLeft : 0;
        });
      };

      intervalOperation();
      oneTimePaymentCountDownInteral = setInterval(intervalOperation, 1000);
    }
    return () => clearInterval(oneTimePaymentCountDownInteral);
  }, [oneTimePaymentExpiryTime]);

  React.useEffect(() => {
    if (oneTimePaymentTimeLeft <= 0) {
      removeOneTimePaymentMethod();
    }
  }, [oneTimePaymentTimeLeft]);

  return {
    oneTimePaymentToken,
    setOneTimePaymentToken,
    oneTimePaymentTimeLeft,
    addOneTimePaymentMethod,
    removeOneTimePaymentMethod
  };
};

export default useOneTimePaymentToken;
